import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ProduktTypGroupServiceConfig = {
  name: "ProduktTypGroup",
  annotations: []
} as ServiceConfig;